import React from 'react';
import {connect} from "react-redux";

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import ChampionshipList from "../common/ChampionshipList";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class SeasonChampionships extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({
            selectedChampionships: [],
            resultSize: '',
            showRaceDetails: false,
            club: '',
            member: '',
            maleCount: '',
            femaleCount: '',
            sortBySex: false,
            sortBySection: false,
        });
    }

    fields = [];
    render() {
        return <div className="season-championships">
            <div className="championship-list">
                <ChampionshipList selectedRaces={this.state.selectedChampionships} updateSelection={this.updateRaceSelection}/>
            </div>
            <div className="report-options">
                <div className="option-group">
                    <div className="result-size">
                        <span className="option">
                            <label htmlFor="resultSize">Antal eller procent (afslut med %) deltagere </label>
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field100" containerClassName="display-inline-block"
                                              name="resultSize" id="resultSize" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]+%?"}]} value={this.state.resultSize}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[0] = instance; }}
                            />
                        </span>
                        <span className="option"><input id="showRaceDetails" name="showRaceDetails" type="checkbox" checked={this.state.showRaceDetails} onChange={this.onCheckFieldChange}/><label htmlFor="showRaceDetails"> Specificér point</label></span>
                    </div>
                </div>
                {/*ONLY FOR DM-SELECTIONS (NOT USED ANY MORE):<div className="option-group">
                    <div className="result-criterias">
                        <span className="option">
                            <label htmlFor="club" style={{width: '350px', display: 'inline-block'}}>Forening </label>
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="club" id="club" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.club}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              onBlur={() => {
                                                  this.fields[1].setState({focused: false, visited: true});
                                                  if (/^[0-9]{1,2}$/.test(this.state.club)) this.setState({club: this.state.club.padStart(3, '0')});
                                              }}
                                              ref={instance => { this.fields[1] = instance; }}
                            />
                        </span>
                        <span className="option">
                            <label htmlFor="member">Slag </label>
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="member" id="member" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.member}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              onBlur={() => {
                                                  this.fields[2].setState({focused: false, visited: true});
                                                  if (/^[0-9]{1,2}$/.test(this.state.member)) this.setState({member: this.state.member.padStart(3, '0')});
                                              }}
                                              ref={instance => { this.fields[2] = instance; }}
                            />
                        </span>
                    </div>
                </div>*/}
                <div className="option-group">
                    <div className="result-criterias">
                        <span className="option">
                            <label htmlFor="maleCount">Kun for due-mesterskaber: Antal hanner </label>
                            <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="maleCount" id="maleCount" value={this.state.maleCount}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[3] = instance; }}
                            />
                        </span>
                        <span className="option">
                            <label htmlFor="femaleCount">Antal hunner </label>
                            <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                              name="femaleCount" id="femaleCount" value={this.state.femaleCount}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[4] = instance; }}
                            />
                        </span>
                    </div>
                </div>
                <div className="option-group">
                    <div className="result-groupings">
                        <span className="option"><input id="sortBySex" name="sortBySex" type="checkbox" checked={this.state.sortBySex} onChange={this.onCheckFieldChange}/><label htmlFor="sortBySex"> Udskriv kønsvist (kun for duemesterskaber)</label></span>
                        {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <span className="option"><input id="sortBySection" name="sortBySection" type="checkbox" checked={this.state.sortBySection} onChange={this.onCheckFieldChange}/><label htmlFor="sortBySection"> Udskriv sektionsvist</label></span> : null}
                    </div>
                </div>
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    onCheckFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.checked ? true : false});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    updateRaceSelection = (championships, add = true) => {
        this.setState({
            selectedChampionships: add ? this.state.selectedChampionships.concat(championships.filter(championship => this.state.selectedChampionships.indexOf(championship) < 0)) : this.state.selectedChampionships.filter(championship => championships.indexOf(championship) < 0)
        })
    };

    getReportOptions = (options) => {
        const errors = [];
        let isValid = true;
        if (typeof(options) === 'undefined' || typeof(options.checkOnlyChampionshipSelection) === 'undefined' || options.checkOnlyChampionshipSelection !== true) {
            isValid = this.allInputValid();
            if (!isValid) {
                errors.push('Der er fejl i et eller flere rapporteringsvalg).');
                this.fields.forEach((field) => {
                    field.setState({visited: true});
                });
            }
        }
        if (this.state.selectedChampionships.length === 0) errors.push('Der er ikke valgt nogen mesterskaber(er).');
        return {
            errors: errors,
            isErrors: !isValid,
            options: {
                championships: this.state.selectedChampionships,
                resultSize: this.state.resultSize === '' ? null : this.state.resultSize,
                showRaceDetails: this.state.showRaceDetails,
                club: this.state.club === '' ? null : this.state.club,
                member: this.state.member === '' ? null : this.state.member,
                maleCount: this.state.maleCount === '' ? null : Number(this.state.maleCount),
                femaleCount: this.state.femaleCount === '' ? null : Number(this.state.femaleCount),
                sortBySex: this.state.sortBySex,
                sortBySection: this.state.sortBySection,
            },
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(SeasonChampionships);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/SeasonChampionships.js